import React from "react";
import { Link } from "react-router-dom";
import "./cta.css";

const BannerCTA = ({ to, text, icon: Icon }) => {
  return (
    <div className="cta-banner">
      <Link to={to}>
        <span className="cta-banner-text">{text}</span>
        {Icon && <Icon className="cta-banner-icon" />}
      </Link>
    </div>
  );
};

export default BannerCTA;
